import React, { useState } from "react";
import { Box, Image } from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { openLanguagePop } from "../../redux/action/member/memberAction";
import useCheckLogin from "../../hook/useCheckLogin";
import useWebsiteInfo from "../../hook/useWebsiteInfo";
import BetRecordForMachine from "./BetRecordForMachine";
import { AnimatePresence } from "framer-motion";

const BetRecordButton = () => {
  const dispatch = useDispatch();
  const { isMachineUser } = useCheckLogin();
  const { images } = useWebsiteInfo();
  const [showBetRecord, setShowBetRecord] = useState(false);

  const handleClick = () => {
    setShowBetRecord(true);
  };

  const handleClose = () => {
    setShowBetRecord(false);
  };

  return (
    <>
      <AnimatePresence>
        {showBetRecord && <BetRecordForMachine onClose={handleClose} />}
      </AnimatePresence>
      <Box
        onClick={handleClick}
        alignItems="center"
        position="relative"
        cursor="pointer"
        display="flex"
        justifyContent="center"
        shadow="sm"
      >
        <Image
          src={images.betRecordICONheader}
          height={{
            base: "30px",
            md: "65px",
            xl: "85px",
          }}
          minW={{
            base: "30px",
            md: "85px",
          }}
          maxW={{
            base: "30px",
            md: "85px",
          }}
        />
      </Box>
    </>
  );
};

export default BetRecordButton;
